module.exports = __webpack_public_path__ + "img/banner_en.7b654afc.jpg";